/**
 * @fileoverview จำหน้าที่ผู้ใช้กดลิงก์มา (เช่น ปุ่มในอีเมลแจ้งเตือน) ระหว่างที่ยังไม่ login
 * แล้วพากลับไปหลัง login + เลือก company เสร็จ
 * เก็บเฉพาะ path ภายในที่ขึ้นต้น /ad/ เพื่อกัน open redirect
 */

const KEY = "cm-return-to";

const isSafe = (path) =>
  typeof path === "string" && path.startsWith("/ad/") && !path.startsWith("//") && !/[\\\s]/.test(path);

export const saveReturnPath = (location) => {
  try {
    const path = `${location?.pathname || ""}${location?.search || ""}`;
    if (isSafe(path)) sessionStorage.setItem(KEY, path);
  } catch (e) {
    // sessionStorage ใช้ไม่ได้ -> ใช้ flow เดิม
  }
};

/** อ่านแล้วลบทิ้งทันที คืน null ถ้าไม่มีหรือไม่ปลอดภัย */
export const takeReturnPath = () => {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return isSafe(path) ? path : null;
  } catch (e) {
    return null;
  }
};
